import { ReactNode } from 'react'

export enum Timeframe {
  CE_MATIN = 'ce matin',
  CE_MIDI = 'ce midi',
  CET_APRÈS_MIDI = 'cet après-midi',
  CE_SOIR = 'ce soir',
  CETTE_NUIT = 'cette nuit',
}

export interface HighFiveProps {
  timeframe: Timeframe | ''
  children: ReactNode
  formattedUpdatedDate: string
}
